function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
// @limitless
import Button from "../../inputs/button/Button";
import { useTranslation } from "@limitless/common/hooks";
const Dialog = ({
  children,
  id = "Dialog-default-id",
  title = "",
  onOkClick,
  okDisabled = false,
  onCancelClick = null,
  cancelVariant = "contained",
  okVariant = "contained",
  okSize = "small",
  cancelSize = "small",
  okText = "Ok",
  paperStyle = {},
  titleStyle = {},
  cancelText = "Cancel",
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(MuiDialog, _extends({
    id: `dialog-${id}`,
    PaperProps: {
      elevation: 1,
      sx: {
        padding: theme => theme.spacing(3),
        maxWidth: "615px",
        ...paperStyle
      }
    },
    fullWidth: true
  }, rest), /*#__PURE__*/React.createElement(DialogTitle, {
    component: "h6",
    variant: "subtitle1",
    sx: {
      paddingBottom: 2,
      ...titleStyle
    }
  }, t(title)), /*#__PURE__*/React.createElement(DialogContent, {
    sx: {
      overflowY: "initial"
    }
  }, children), /*#__PURE__*/React.createElement(DialogActions, null, onCancelClick && /*#__PURE__*/React.createElement(Button, {
    onClick: onCancelClick,
    autoFocus: true,
    variant: cancelVariant,
    size: cancelSize
  }, t(cancelText)), /*#__PURE__*/React.createElement(Button, {
    onClick: onOkClick,
    autoFocus: true,
    variant: okVariant,
    disabled: okDisabled,
    size: okSize
  }, t(okText))));
};
Dialog.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  onOkClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func,
  okText: PropTypes.string,
  cancelVariant: PropTypes.string,
  okSize: PropTypes.string,
  paperStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  cancelSize: PropTypes.string,
  okVariant: PropTypes.string,
  okDisabled: PropTypes.bool,
  cancelText: PropTypes.string
};
export default Dialog;